<template>
  <div id="position">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>
<script>
export default {
  name: 'position'
}
</script>




// WEBPACK FOOTER //
// src/views/exhibition/booth/position/Position.vue